import * as common from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, HttpModule, RequestOptions } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    AuthService,
    authServiceFactory,
    AUTH_CONFIG,
    DatatableModule,
    DatatableService,
    HttpService,
    VersionTagModule
} from '@basis/angular-components';
import { AuthHttp, JwtHelper } from 'angular2-jwt';
import { environment } from 'environments/environment';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { BreadcrumbService } from 'ng5-breadcrumb';
import { NgProgressModule } from 'ngx-progressbar';
import * as primeng from 'primeng/primeng';
import { BlockUIModule, OverlayPanelModule } from 'primeng/primeng';
import 'rxjs/add/operator/toPromise';
import { AppComponent } from './app.component';
import { AppFooterComponent } from './app.footer.component';
import { AppMenuComponent, AppSubMenu } from './app.menu.component';
import { InlineProfileComponent } from './app.profile.component';
import { AppRoutes } from './app.routes';
import { AppTopBarModule } from './app.topbar.module';
import { AuthGuard } from './autenticacao/auth.guard';
import { authHttpServiceFactory } from './autenticacao/auth.module';
import { BaseBarProgressComponent } from './base/base-barprogress.component';
import { Erro403Component } from './erros';
import { ModulosComponent } from './modulos';
import { PadraoService } from './service/padrao.service';
import { AutenticacaoService } from './service/autenticacao.service';
import { CustomBreadcrumbComponent } from './util/custom-breadcrumb.component';
import { Helpers } from './util/helpers';
import { Locale } from './util/locale.ptbr';
import * as observableUtil from './util/observable-util';
import { DecToTimePipe } from './util/pipe-cargahoraria';
import { FormatSelectItemPipe } from './util/pipe-selecao';
import { SelectItemPipe } from './util/pipe-select-item';
import { TelefoneMaskPipe } from './util/pipe-telefone';
import { ModulosModule } from './modulos/modulos.module';
import {TipoAtividadeModule} from './tipo-atividade/tipo-atividade.module';
import {RelatorioService} from './service/relatorio.service';
registerLocaleData(localePt);

@NgModule({
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        BlockUIModule,
        NgProgressModule,
        AppRoutes,
        HttpModule,
        BrowserAnimationsModule,
        primeng.DialogModule,
        primeng.DragDropModule,
        primeng.DropdownModule,
        AppTopBarModule,
        CurrencyMaskModule,
        primeng.GrowlModule,
        primeng.ConfirmDialogModule,
        primeng.FieldsetModule,
        //primeng.StepsModule,
        // ModulosModule,
        DatatableModule.forRoot(),
        VersionTagModule,
        OverlayPanelModule
    ],
    declarations: [
        BaseBarProgressComponent,
        AppComponent,
        AppMenuComponent,
        AppSubMenu,
        AppFooterComponent,
        ModulosComponent,
        InlineProfileComponent,
        CustomBreadcrumbComponent,
        Erro403Component,
        // CrudCursoPrestacaoContaComponent,
        // CrudCursoPrestacaoContaEtapa1Component,
        // CrudCursoPrestacaoContaEtapa2Component,
        // CrudCursoPrestacaoContaEtapa3Component,
        // CrudCursoPrestacaoContaEtapa4Component,
        // CrudEventoPrestacaoContaComponent,
    ],
    providers: [
        {
            provide: LOCALE_ID,
            useValue: 'pt'
        },
        {
            provide: common.LocationStrategy,
            useClass: common.HashLocationStrategy
        },
        {
            provide: DatatableService,
            useClass: DatatableService,
            deps: [AuthHttp]
        },
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [Http, RequestOptions]
        },
        {
            provide: AUTH_CONFIG,
            useValue: environment.auth
        },
        {
            provide: AuthService,
            deps: [HttpService, AUTH_CONFIG],
            useFactory: authServiceFactory
        },
        RelatorioService,
        primeng.ConfirmationService,
        AutenticacaoService,
        PadraoService,
        FormatSelectItemPipe,
        SelectItemPipe,
        DecToTimePipe,
        TelefoneMaskPipe,
        BreadcrumbService,
        common.CurrencyPipe,
        AuthGuard,
        observableUtil.ObservableVariable,
        observableUtil.ObservableLotacao,
        observableUtil.bObservableUsuario,
        observableUtil.ObservableBlockPanel,
        observableUtil.ObservableBlockPanelDoc,
        observableUtil.bObservableListaPrestacaoConta,
        Locale,
        Helpers,
        JwtHelper,
        AuthService,
        HttpService,
        //NoSanitizePipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts